import { render, staticRenderFns } from "./workforce_info.vue?vue&type=template&id=aae3e604&scoped=true"
import script from "./workforce_info.vue?vue&type=script&lang=js"
export * from "./workforce_info.vue?vue&type=script&lang=js"
import style0 from "./workforce_info.vue?vue&type=style&index=0&id=aae3e604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae3e604",
  null
  
)

export default component.exports